// @flow

import * as React from 'react';
import styles from './CurrencyPreviewContents.less';
import type { CurrencyPreview } from './types';

type Props = {
  /** Data for the currency preview */
  preview: CurrencyPreview,
};

/** Contents for the preview, showing current currency */
const CurrencyPreviewContents = ({ preview }: Props) => (
  <div>
    <span className={styles.symbol}>{preview.symbol}</span>
    {preview.code}
  </div>
);

export default CurrencyPreviewContents;
